import { Slider } from '../card-slider/slider.js';

class EventTabs {
	constructor( node ) {
		this.node     = node;
		this.index    = -1;
		this.links    = this.node.querySelectorAll( '.event-tabs__header .event-tabs__nav-link' );
		this.back     = this.node.querySelector( '.event-tabs__go--back' );
		this.forward  = this.node.querySelector( '.event-tabs__go--forward' );
		this.contents = this.node.querySelectorAll( '.event-tabs__tab' );
		this.sliders  = [ ...this.contents ].map( content => new Slider( content, {
			content,
			items: '.event-tabs__event',
		} ) );

		this.back.addEventListener( 'click', () => {
			if ( this.sliders[ this.index ] ) {
				this.sliders[ this.index ].backIndex();
			}
		} );

		this.forward.addEventListener( 'click', () => {
			if ( this.sliders[ this.index ] ) {
				this.sliders[ this.index ].forwardIndex();
			}
		} );

		this.sliders.forEach( ( slider, index ) => {
			slider.content.addEventListener( 'scroll', () => {

				if ( index === this.index ) {
					this.setState();
				}
			} );
		} );

		this.activate( 0 );
		this.links.forEach( ( link, index ) => link.addEventListener( 'click', () => this.activate( index ) ) );
	}

	setState() {
		if ( this.sliders[ this.index ] ) {
			this.sliders[ this.index ].setState();

			if ( this.sliders[ this.index ].back.disabled ) {
				this.back.disabled = true;
			} else {
				this.back.removeAttribute( 'disabled' );
			}

			if ( this.sliders[ this.index ].forward.disabled ) {
				this.forward.disabled = true;
			} else {
				this.forward.removeAttribute( 'disabled' );
			}
		}
	}

	activate( index ) {
		if ( this.index > -1 ) {
			if ( this.links[ this.index ] ) {
				this.links[ this.index ].classList.remove( 'event-tabs__nav-link--active' );
			}

			if ( this.contents[ this.index ] ) {
				this.contents[ this.index ].classList.remove( 'event-tabs__tab--active' );
			}
		}

		this.index = index;

		if ( this.index > -1 ) {
			if ( this.links[ this.index ] ) {
				this.links[ this.index ].classList.add( 'event-tabs__nav-link--active' );
			}

			if ( this.contents[ this.index ] ) {
				this.contents[ this.index ].classList.add( 'event-tabs__tab--active' );
			}
		}

		this.setState();
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	for ( const node of document.querySelectorAll( '.event-tabs' ) ) {
		new EventTabs( node );
	}
} );
